var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    transform: "rotate(0,128,128) translate(21,27.6875) scale(6.6875,6.6875)",
    fill: "#2dd5ff",
    d: "M14,19L14,19.5C14,20.878 15.122,22 16.5,22 17.878,22 19,20.878 19,19.5L19,19z M2,16.765711L2,28 30.000999,28 30.000408,16.765831 27.701994,18.145C26.769995,18.705,25.701994,19,24.614996,19L21,19 21,19.5C21,21.981001 18.981,24 16.5,24 14.019,24 12,21.981001 12,19.5L12,19 7.3850079,19C6.2980086,19,5.2300093,18.704,4.2980099,18.145z M2,9L2,14.433969 5.3270092,16.43C5.9480088,16.803001,6.6600083,17,7.3850079,17L13,17 20,17 24.614996,17C25.339994,17,26.051994,16.803001,26.672995,16.43L30.000286,14.434323 30,9 23,9 9,9z M12,2C10.897003,2,10,2.8970032,10,4L10,7 22,7 22,4C22,2.8970032,21.102997,2,20,2z M12,0L20,0C22.205994,0,24,1.7939987,24,4L24,7 30,7C31.103001,7,32,7.8969998,32,9L32,28C32,29.103001,31.103001,30,30,30L2,30C0.89699984,30,0,29.103001,0,28L0,9C0,7.8969998,0.89699984,7,2,7L8,7 8,4C8,1.7939987,9.7940063,0,12,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.ecb6c2bc70d2623dd872db38e3a99c61.svg";
export { ForwardRef as ReactComponent };